import { Image } from "antd";
import React from "react";

function PageIntro({ headingOne, headingTwo }) {
  return (
    <div className="relative">
      <Image src="/newsBanner.svg" alt="newsBanner" preview={false} />
      <div className="absolute top-0 flex flex-col justify-center items-center w-full h-full">
        <h1 className="text-5xl font-bold text-[#ffffff] z-10 max-[769px]:text-[20px] max-[481px]:text-[12px] mt-[10px]">
          {headingOne}
        </h1>
        <h3 className="text-base font-normal text-[#ffffff] z-10 max-[769px]:text-[16px] max-[481px]:text-[12px]">
          {headingTwo}
        </h3>
      </div>
    </div>
  );
}

export default PageIntro;
